export function isValidEnum(str, map) {
    return str in map;
}
export const arrays_equal = (a, b) => !!a && !!b && !(a < b || b < a);
export function deltaReducer(reducer) {
    return (state, action) => (Object.assign(Object.assign({}, state), reducer(state, action)));
}
